import React, {useContext, useState} from "react";
import {AuthContext} from "../../contexts/auth/AuthContext";
import {Navigate} from "react-router-dom";
import StatusBar from "../StatusBar/StatusBar";
import {Col, Container, Row} from "react-bootstrap";
import './DailyCheckIn.css';
import DatumSelection from "./DatumSelection/DatumSelection";
import {SelectedDateContext} from "../../contexts/date/SelectedDateContext";
import {useIntl} from "react-intl";
import {getLocale} from "../../contexts/language/LanguageContext";
import DailyCheckInStatus from "./DailyCheckInStatus/DailyCheckInStatus";

const DailyCheckIn = () => {
    const intl = useIntl();
    const [authContext, ] = useContext(AuthContext);
    const [selectedDateContext, setSelectedDateContext ] = useState(new Date());


    if (!authContext.isAuthenticated) {
        return <Navigate to="/login"/>
    } else {
        return (
            <SelectedDateContext.Provider value={[selectedDateContext, setSelectedDateContext]}>
                <Container fluid className={'check-in-container'}>
                    <StatusBar />
                    <Row>
                        <Col md={12} lg={{span: 6, offset: 3}}>
                            <DailyCheckInStatus />
                        </Col>
                        <Col md={12} lg={{span: 6, offset: 3}}>
                            <DatumSelection />
                        </Col>
                    </Row>
                </Container>
            </SelectedDateContext.Provider>

        );
    }
}

export default DailyCheckIn;